







import Vue from 'vue'

export default abstract class ProductPreview extends Vue {
    
    abstract get activeComponent():string
}
